import type { Config } from "dompurify"

let renderer: Promise<{
  parse: (text: string) => Promise<string> | string
  sanitize: (html: string, config?: Config) => string
}> | undefined

export async function dashboardMarkdownHtml(text: string) {
  const active = await markdownRenderer()
  const value = await active.parse(text)
  const safe = active.sanitize(value, {
    USE_PROFILES: { html: true, mathMl: true },
    SANITIZE_NAMED_PROPS: true,
    FORBID_CONTENTS: ["style", "script"],
  })
  return safe || active.sanitize(value, {
    USE_PROFILES: { html: true },
    SANITIZE_NAMED_PROPS: true,
    FORBID_CONTENTS: ["style", "script"],
  })
}

function markdownRenderer() {
  renderer ??= Promise.all([
    import("@opencode-ai/ui/context/marked-parser"),
    import("dompurify"),
  ]).then(([markdown, dompurify]) => {
    const parser = markdown.createMarkdownParser((code, language) =>
      `<pre><code class="language-${escapeHtml(language)}">${escapeHtml(code)}</code></pre>`,
    )
    const purifier = dompurify.default(window)
    return { parse: (text: string) => parser.parse(text), sanitize: purifier.sanitize.bind(purifier) }
  })
  return renderer
}

function escapeHtml(value: unknown) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;")
}
